import React from "react";

function Hero() {
  
  return (
    <section id="home" className="hero-section-wrapper-5">

      <div
        className="hero-section hero-style-5 img-bg"
        style={{
          backgroundImage: "url('/assets/img/hero/hero-bg.svg')",
        }}
      >
        <div className="container">
          <div className="row">

            {/* LEFT */}
            <div className="col-lg-6">
              <div className="hero-content-wrapper">

                <h2
                  className="mb-30 wow fadeInUp"
                  data-wow-delay=".2s"
                >
                  Tutoring for SAT, ACT, APs
                </h2>

                <h5
                  className="mb-10 wow fadeInUp"
                  data-wow-delay=".2s"
                >
                  Confidence Starts with the Right Guidance Version
                </h5>

                <p
                  className="mb-30 wow fadeInUp"
                  data-wow-delay=".4s"
                >
                  We build subject mastery and prepare your child for the SATs exams so they can tackle them with confidence.
                </p>

                <a
                style={{ backgroundColor: "#3b52ff" }}
                  href="#contact"
                  className="button button-lg radius-50 wow fadeInUp"
                  data-wow-delay=".6s"
                >
                  Book a Free Trial <i className="lni lni-chevron-right"></i>
                </a>

              </div>
            </div>

            {/* RIGHT */}
            <div className="col-lg-6 align-self-end">
              <div
                className="hero-image wow fadeInUp"
                data-wow-delay=".5s"
              >
                <img
                  src="/assets/img/hero/hero-img.svg"
                  alt="hero"
                />
              </div>
            </div>

          </div>
        </div>
      </div>

    </section>
  );
}

export default Hero;